export default __webpack_public_path__ + "static/media/CommonTensileTableImg2.bf8710ec.jpg";